import api from "./api";
import {
  CodigoValidacao,
  ConviteFranquiaInput,
  PaginatedCodigoValidacaoResponse,
} from "../types/codigoValidacao";

class CodigoValidacaoService {
  async criar(data: ConviteFranquiaInput): Promise<CodigoValidacao> {
    const response = await api.post<CodigoValidacao>(
      "/api/codigos-validacao/",
      data
    );
    return response.data;
  }

  async listar(
    page: number = 1,
    pageSize: number = 10
  ): Promise<PaginatedCodigoValidacaoResponse> {
    const response = await api.get<PaginatedCodigoValidacaoResponse>(
      `/api/codigos-validacao/?page=${page}&page_size=${pageSize}`
    );
    return response.data;
  }

  async getCodigoPorId(id: string): Promise<CodigoValidacao> {
    const response = await api.get<CodigoValidacao>(
      `/api/codigos-validacao/${id}/`
    );
    return response.data;
  }

  async revogar(id: string): Promise<CodigoValidacao> {
    const response = await api.post<CodigoValidacao>(
      `/api/codigos-validacao/${id}/revogar/`
    );
    return response.data;
  }

  async verificarCodigo(id: string): Promise<{ status: string }> {
    const response = await api.get<{ status: string }>(
      `/api/codigos-validacao/${id}/verificar-codigo/`
    );
    return response.data;
  }

  async verificarEmail(id: string, email: string): Promise<CodigoValidacao> {
    const response = await api.post<CodigoValidacao>(
      `/api/codigos-validacao/${id}/verificar-email/`,
      { email }
    );
    return response.data;
  }
}

export const codigoValidacaoService = new CodigoValidacaoService();
